<template>
  <v-dialog
    v-model="showDialog"
    no-click-animation
    persistent
    width="500"
    :transition="false"
  >
    <v-card>
      <v-card-title>{{ $t('members.notPermission') }}</v-card-title>
      <v-card-text>{{ $t('members.contactOwner') }}</v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="primary"
          @click="hide"
        >
          {{ $t('members.backButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "HelperPermissionDialog",
  data: () => ({
    message: null,
    showDialog: false
  }),
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "app/setShowPermission") {
        this.showDialog = true;
      }
    });
  },
  methods: {
    ...mapMutations("app", ["setShowPermission"]),
    hide() {
      this.setShowPermission(null);
      this.showDialog = false;
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="scss" scoped>
  .v-card__title {
    word-break: break-word;
  }
</style>
